import React from 'react';
import { Tag } from './Tag';
import { cn } from '../lib/utils';
const TagsDictionary = {
    'Best Sellers': 'best-seller',
    New: 'new',
};
const ProductTag = ({ tag, children, className, }) => {
    if (tag !== 'New' && tag !== 'Best Sellers') {
        return null;
    }
    return (React.createElement(Tag, { size: "lg", className: cn('absolute top-2.5 right-2.5 md:right-3', className), variant: TagsDictionary[tag] }, children));
};
export default ProductTag;
